import { CellContext } from '@tanstack/react-table';
import timeUtils from '@/utils/timeUtils.ts';
import { CellSecondary } from '@/components/table/_fieldDefinitions/_base/CellSecondary.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const dateTimeFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue() as string | null;
  if (!value) return <EmptyValue />;

  const { main, secondary } = timeUtils.splitDateTime(value);
  return (
    <>
      {main}
      <CellSecondary>{secondary}</CellSecondary>
    </>
  );
};
